import Vue from 'vue';

const failed = (error, context) => {
  context.loading = false;
  context.showToasterError(error);
};

const success = (response, context) => {
  context.bookings = response.data.bookings;
  context.isLoading = false;
  context.rentals = response.data.rentals;
  context.loading = false;
  context.user.currency = response.data.currency;
  context.totalCount = response.data.total_count;
  context.lastPage = response.data.count;
  if (context.bookings.length === 0) {
    context.filteredEmpty = true;
  } else {
    context.filteredEmpty = false;
  }
};

export default (context, limit, page, text = null,
  status = null, checkedRentals = '', orderByField, orderByType) => Vue.$http.get(`/get-filtered-bookings?limit=${limit}&offset=${page}&searchText=${text}
  &status=${status}&filterByRentalId=${checkedRentals}&orderByField=${orderByField}&orderByType=${orderByType}`,
  )
    .then((response) => {
      if (response && response.status === 200) {
        success(response, context, limit);
      }
    })
    .catch((error) => {
      failed(error, context);
    });



// WEBPACK FOOTER //
// ./src/app/services/booking/getBookingsForSorting.js